import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getIssuesComponent, getErrorIssues, getWarningIssues } from '../../../../../../../utils/validationSummary';

class PropertyPicker extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.property.value,
            error: +this.props.property.value < this.getMin(this.props.property.value) || +this.props.property.value > this.getMax(this.props.property.value)
        };

        this.handleChange = this.handleChange.bind(this);
        this.getMin = this.getMin.bind(this);
        this.getMax = this.getMax.bind(this);
    }

    getMin(value) {
        return ('' + value) !== this.props.property.valueMeta.off ? +this.props.min : Math.min(this.props.min, this.props.property.valueMeta.off);
    }

    getMax(value) {
        return ('' + value) !== this.props.property.valueMeta.off ? +this.props.max : Math.max(this.props.max, this.props.property.valueMeta.off);
    }

    handleChange(e) {

        const value = e.target.value; //'+parseInt(e.target.value);

        this.setState({
            value: value,
            error: +value < this.getMin(value) || +value > this.getMax(value)
        });

        //Add it to have a generic message in english. The error text, in case the value is out of range, is autogenerated in the language of the pc
        if (!e.target.validity.valid) {
            e.target.title = value < this.getMin(value) ? `Select a value greater than ${this.getMin(value)}` : `Select a value lower than ${this.getMax(value)}`;
        }
        else {
            e.target.title = '';
        }

        this.props.handleChange(this.props.property.info.name, value);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.property.value !== prevProps.property.value) {
            this.setState({ value: this.props.property.value });
        }

        //needed when handleChange is triggered from other component, the props are updated but not the state
        if (this.props.property.value !== prevState.value) {
            this.setState({ value: this.props.property.value });
        }

        if (this.props.property.value !== prevProps.property.value
            || this.props.min !== prevProps.min
            || this.props.max !== prevProps.max) {
            this.setState({ error: +this.props.property.value < this.getMin(this.props.property.value) || +this.props.property.value > this.getMax(this.props.property.value) });
        }
    }

    render() {

        const errors = getErrorIssues(this.props.issues, this.props.property);
        const warnings = getWarningIssues(this.props.issues, this.props.property);

        const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

        return (
            <Row style={{ margin: "0.75rem auto 0" }}>
                <Col style={{ paddingLeft: '0', display: "flex" }} sm={4}>
                    {this.props.title}
                    {/* {this.props.title.replace(/([A-Z])/g, ' $1')} */}
                </Col>

                <Col sm={5} className={this.props.inputPadding ? this.props.inputPadding : ''} style={{ maxWidth: "6rem", display: "flex", flexDirection: "column" }}>
                    <input
                        disabled={this.props.disabled}
                        className={className}
                        name={this.props.property.info.name}
                        type="number"
                        min={this.props.min}
                        max={this.props.max}
                        step={this.props.step}
                        value={!isNaN(this.state.value) ? this.state.value : ''}
                        onChange={this.handleChange} />

                    {getIssuesComponent(errors, warnings)}
                </Col>
                <Col sm={3} style={{ padding: '0', justifyContent: "center", display: "flex" }}>
                    {this.props.measureUnit}
                </Col>
            </Row>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        issues: state.ledmodule.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyPicker);